import * as ROUTES from '../routes';


const Navigations = [
    {
        title: "Workforce",
        icon: "mdi-account-hard-hat",
        to: ROUTES.ADMINS,
        mini: false,
        permissions: ['can_view_admins'],
        subNav: [
            {
                title: "Administrators",
                to: ROUTES.ADMINS,
                icon: 'mdi-account-group'
            },
            {
                title: 'Teams',
                to: ROUTES.TEAMS,
                icon: 'mdi-account-multiple-plus'
            },
            {
                title: 'Audit Logs',
                to: ROUTES.AUDIT,
                icon: 'mdi-text-box-search'
            }
        ]
    },
]

export default Navigations
